import React from 'react';
import OryzaDgreen from "../partials/images/icon/oryzacollection_dgreen.png";
import "../partials/main.min.css";
import "../partials/bootstrap.min.css";
import "../partials/style.css";

export default function footer() {
  return (
    <div>
      <footer className="footer bg-parallax">
        <div className="bg-overlay bg-overlay--p85"></div>
        <div className="container">
          <div className="row alignfooter">
            <div className="col-lg-5 col-md-6">
              <div className="footer-col">
                <div className="widget m-b-25">
                  <a href="/oryza/oryzaleisure">
                    <img
                      className="collectionsize"
                      src={OryzaDgreen}
                      alt="Oryza Hotels"
                    />
                  </a>
                </div>
                <div className="widget widget-address">
                  <ul>
                    <li>
                      <b>Address: </b>No 178, 2/2, Stanley Thilakarathna
                      Mawatha, Nugegoda
                    </li>
                    <li>
                      <b>Phone number: </b>
                      <a className="color_secondary" href="tel:+94767008800">
                        +94 76 700 8800
                      </a>
                    </li>
                    <li>
                      <b>Email: </b>
                      <a
                        className="color_secondary"
                        href="mailto:reservations@oryzaleisure.com"
                      >
                        reservations@oryzaleisure.com
                      </a>
                    </li>
                    <div className="widget widget_socials">
                      <ul className="list-social list-social-2">
                        <li className="list-social__item">
                          <a
                            className="ic-fb"
                            href="https://www.facebook.com/oryzaleisure"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i
                              style={{ color: "#1b352c" }}
                              className="zmdi zmdi-facebook"
                            ></i>
                          </a>
                        </li>
                        <li className="list-social__item">
                          <a
                            className="ic-insta"
                            href="https://www.instagram.com/oryzaleisure"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i
                              style={{ color: "#1b352c" }}
                              className="zmdi zmdi-instagram"
                            ></i>
                          </a>
                        </li>
                        <li className="list-social__item">
                          <a
                            className="ic-whatsapp"
                            href="https://wa.me/94767008800"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i
                              style={{ color: "#1b352c" }}
                              className="zmdi zmdi-whatsapp"
                            ></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer-col p-l-70 p-md-l-0">
                <div className="widget widget_pages">
                  <h4 className="widget-title color_secondary">
                    #OryzaLeisure
                  </h4>
                  <ul className="listspacing">
                    <li>
                      <a className="color_secondary" href="/oryza/oryzaleisure">
                        About Oryza Leisure
                      </a>
                    </li>
                    <li>
                      <a className="white" href="/oryza/offers">
                        Offers
                      </a>
                    </li>
                    <li>
                      <a className="white" href="/oryza/contact">
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="footer-col p-l-70 p-md-l-0">
                <div className="widget widget_pages">
                  <h4 className="widget-title color_secondary">
                    Oryza Destinations
                  </h4>
                  <ul className="listspacing">
                    <li>
                      <a
                        className="color_secondary"
                        href="https://pettipettimirissa.com"
                      >
                        Petti Petti Mirissa
                      </a>
                    </li>
                    <li>
                      <a
                        className="white"
                        href="https://kentcottagenuwaraeliya.com"
                      >
                        Kent Cottage Nuwara Eliya
                      </a>
                    </li>
                    <li>
                      <a className="white" href="https://bananabunkskandy.com">
                        Banana Bunks Kandy
                      </a>
                    </li>
                    <li>
                      <a
                        className="white"
                        href="https://bananabunksmirissa.com"
                      >
                        Banana Bunks Mirissa
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="footer-second bg-parallax">
        <div className="row">
          <div className="col-lg-4 col-sm-12 white center">
            <p className="footer-p">
              © 2024 Oryza Leisure Pvt Ltd. All Rights Reserved.
            </p>
          </div>
          <div className="col-lg-4 col-sm-12 white center">
            <p className="footer-p">
              <a className="white" href="/oryza">
                Privacy Policy
              </a>{" "}
              |{" "}
              <a className="white" href="/oryza">
                Terms and Conditions
              </a>
            </p>
          </div>
          <div className="col-lg-4 col-sm-12 white center">
            <p className="footer-p">
              Designed and Developed by{" "}
              <a
                className="white"
                href="https://ollcode.com"
                target="_blank"
                rel="noreferrer"
              >
                <b>Ollcode</b>
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
